module.exports = __webpack_public_path__ + "static/foto-martin-7d7162a4aa22954c52bef27c4c1feb06.png";